import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './apiBaseQuery';

// Define a service using a base URL and expected endpoints
export const api = createApi({
  baseQuery: apiBaseQuery(),
  endpoints: (builder) => ({
    acceptInvite: builder.mutation({
      query: (data) => {
        return { url: '/api/v2/users/invites/accept', method: 'post', data };
      },
    }),
    forgotPassword: builder.mutation({
      query: ({ email }) => {
        return {
          url: '/api/v2/password/forgot',
          method: 'post',
          data: {
            email_address: email,
          },
        };
      },
    }),
    getInvites: builder.query({
      query: (token) => ({ url: `/api/v2/users/invites/${token}`, method: 'get' }),
    }),
    googleLogin: builder.mutation({
      query: (data) => ({
        url: '/api/v2/google/login',
        method: 'post',
        data,
        context: 'Google Login',
      }),
    }),
    googleSignUp: builder.mutation({
      query: (data) => ({
        url: '/api/v2/google/signup',
        method: 'post',
        data,
        context: 'Google Signup',
      }),
    }),
    login: builder.mutation({
      query: ({ email, password }) => {
        return {
          url: '/api/v2/users/login',
          method: 'post',
          data: {
            password,
            email_address: email,
          },
        };
      },
    }),
    streamlinedLogin: builder.mutation({
      query: ({ code }) => {
        return {
          url: '/api/v2/users/login',
          method: 'post',
          data: { code },
        };
      },
    }),
    loginSSO: builder.mutation({
      query: (email) => ({
        url: '/sso/login',
        method: 'post',
        data: {
          email,
        },
        context: 'Login SSO',
      }),
    }),
    microsoftLogin: builder.mutation({
      query: ({ accessToken }) => ({
        url: '/api/v2/microsoft/login',
        method: 'post',
        data: {
          code: accessToken,
        },
        context: 'Microsoft Login',
      }),
    }),
    microsoftSignUp: builder.mutation({
      query: ({ accessToken }) => ({
        url: '/api/v2/microsoft/signup',
        method: 'post',
        data: {
          code: accessToken,
        },
        context: 'Microsoft Signup',
      }),
    }),
    googleMerge: builder.mutation({
      query: ({ code }) => ({
        url: '/api/v2/google/merge',
        method: 'post',
        data: {
          code,
        },
        context: 'Google Merge',
      }),
    }),
    resetPassword: builder.mutation({
      query: (data) => {
        return {
          url: '/api/v2/password/reset',
          method: 'post',
          data,
        };
      },
    }),
    signUp: builder.mutation({
      query: ({ firstName, lastName, email, password }) => {
        return {
          url: '/api/v2/users/signup',
          method: 'post',
          data: {
            first_name: firstName,
            last_name: lastName,
            email_address: email,
            password,
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetInvitesQuery,
  useAcceptInviteMutation,
  useGoogleLoginMutation: useGoogleLogin,
  useGoogleSignUpMutation: useGoogleSignUp,
  useLoginMutation: useLogin,
  useStreamlinedLoginMutation: useStreamlinedLogin,
  useLoginSSOMutation: useLoginSSO,
  useMicrosoftLoginMutation: useMicrosoftLogin,
  useMicrosoftSignUpMutation: useMicrosoftSignUp,
  useGoogleMergeMutation: useGoogleMerge,
  useForgotPasswordMutation: useForgotPassword,
  useResetPasswordMutation: useResetPassword,
  useSignUpMutation: useSignUp,
} = api;
